import ShipmentLot from './shipment-lot-container';

export default ShipmentLot;